<template>
    <div v-loading="loading">
        <div class="header-btn">
            <el-button type="warning" size="small" icon="el-icon-plus" @click="openCreate"></el-button>
        </div>

        <el-form inline ref="form" :model="queryForm" style="text-align: center">
            <el-form-item>
                <el-input clearable v-model="queryForm.phone" placeholder="Phone"></el-input>
            </el-form-item>

            <el-button type="primary" icon="el-icon-search" circle @click="loadData"></el-button>
        </el-form>

        <el-table
                fit
                stripe
                highlight-current-row
                v-loading="loading"
                class="data-table"
                :data="data">
            <el-table-column
                    header-align="center"
                    align="center"
                    v-for="item in [
                        {prop:'userName',label:'User Name',wth:'160px'},
                        {prop:'phone',label:'Phone',wth:'120px'},
                        {prop:'email',label:'Email'},
                        // {prop:'bid',label:'Code',wth:'130px'},
                        // {prop:'role',label:'Role',fmt:roleFmt,wth:'80px'},
                        {prop:'status',label:'Status',fmt:statusFmt,wth:'80px'},
                        {prop:'updateTime',label:'Updated Time',fmt:selfTimeFormat},
                    ]"
                    :formatter="item.fmt"
                    :prop="item.prop"
                    :width="item.wth"
                    :label="item.label"
                    :key="item.label">
            </el-table-column>

            <el-table-column label="Action" width="120px" align="center">
                <template slot-scope="s">
                    <el-button type="primary" icon="el-icon-edit" circle @click="openEdit(s.row)"></el-button>

                    <el-tooltip :content="s.row.status===2?'Activate':'Deactivate'" placement="top">
                        <el-button type="text" circle @click="changeStatus(s.row)"
                                   :style="s.row.status===2?'background-color: #19be6b;color: white':'background-color: #FF3030;color: white'"
                                   :icon="s.row.status===2?'el-icon-turn-off':'el-icon-open'"></el-button>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>

        <div class="page">
            <el-pagination @current-change="loadData"
                           :page-size="page.size"
                           :current-page.sync="page.page"
                           :page-count="page.totalPage"
                           layout="prev, pager, next"
                           :total="data.total">
            </el-pagination>
        </div>

        <el-dialog
                v-if="dialogVisible"
                center
                :close-on-click-modal="false"
                :visible.sync="dialogVisible"
                width="700px">
            <el-form ref="form" :model="form" :rules="rules" label-width="100px" label-position="left">
                <el-form-item prop="userName" label="User Name">
                    <el-input v-model="form.userName" placeholder="Enter user name"></el-input>
                </el-form-item>

                <el-form-item prop="phone" label="Phone">
                    <el-input v-model="form.phone" placeholder="Enter phone number"></el-input>
                </el-form-item>

                <el-form-item prop="password" label="Password" :required="isCreate">
                    <el-input v-model="form.password" placeholder="Enter password"></el-input>
                </el-form-item>

                <el-form-item prop="email" label="Email">
                    <el-input v-model="form.email" placeholder="Enter email address"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveData">Save</el-button>
                <el-button @click="dialogVisible = false">Cancel</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {helperAdminList, changeStatus, updateHelperAdmin, createHelperAdmin} from '@/api/UsersAPI'

    export default {
        name: "HelperAdmin",
        data: function () {
            return {
                dialogVisible: false,
                isCreate: false,
                form: {},
                queryForm: {},
                loading: false,
                data: [],
                page: {'page': 1, 'size': 10, 'totalPage': 1, 'total': 0},
                rules: {
                    phone: [
                        {required: true, message: 'Please input phone number', trigger: 'blur'},
                    ],
                }
            }
        },
        methods: {
            loadData() {
                this.$pageUtils(this, helperAdminList)
            },
            statusFmt(row, col, cell) {
                return cell === 1 ? 'Active' : 'InActive'
            }, changeStatus(data) {
                changeStatus(data.id)
                    .then(this.loadData);
            },
            openCreate() {
                this.form = {}
                this.isCreate = true
                this.dialogVisible = true
            },
            openEdit(row) {
                this.form = this.$copy(row);
                this.dialogVisible = true
            },
            saveData() {
                const action = this.form.id ? updateHelperAdmin : createHelperAdmin;
                this.$refs['form'].validate((valid) => {
                    const form = this.$copy(this.form)
                    if (form.password) {
                        form.password = this.$md5(form.password)
                    }
                    if (valid) {
                        action(form)
                            .then(() => {
                                this.loadData()
                                this.dialogVisible = false
                            });
                    }
                })
            }
        },
        mounted() {
            this.loadData()
        }
    }
</script>

<style scoped>
    .el-button{
        margin-right: 5px;
    }
</style>
